import { Box, BoxProps } from '@osmosis/tailwind-ui/components/Box';
import { Button, ButtonProps } from '@osmosis/tailwind-ui/components/Button';
import { ReactNode } from 'react';

type Props = {
  content: ReactNode;
  dataTestId: string;
  containerProps?: BoxProps;
  labelProps?: ButtonProps;
  cursor?: string;
  onLabelClick?: () => void;
  tabIndex?: number;
  as?: 'button' | 'div';
};

/**
 * It renders LabelComponent.
 */
export const LabelComponent = (props: Props) => {
  const {
    content,
    dataTestId,
    containerProps = {},
    labelProps = {},
    cursor = 'pointer',
    onLabelClick,
    tabIndex,
    as = 'button',
  } = props;

  return (
    <Box
      data-testid="label.wrapper"
      style={{
        overflowWrap: 'break-word',
      }}
      {...containerProps}
    >
      <Button
        data-testid={dataTestId}
        onClick={onLabelClick}
        tabIndex={tabIndex}
        as={as as any}
        style={{
          cursor: cursor,
        }}
        {...labelProps}
        className={`bg-[#6D52CD] hover:bg-[#6D52CD] active:bg-[#6D52CD] p-[0.5em] text-[12px] h-[20px] min-w-[40px]`}
      >
        {content}
      </Button>
    </Box>
  );
};
